module.exports = __webpack_public_path__ + "static-portal/img/xzz-gggl.b8a3526.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/xzz-gggl.jpg
// module id = bJhc
// module chunks = 4